/* assets/bpb-configurateur.js
   Fonctionne comme des blocs à l'intérieur de la section "Informations produit" (main-product.liquid). */
(function(){
  function fmt(n){ return n.toLocaleString('fr-FR') + ' €'; }

  function addPendingSupplements(variantIds){
    console.log('[BPB] suppléments détectés :', variantIds);
    if (!variantIds.length) return;

    var cartEl = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var sectionIds = (cartEl && typeof cartEl.getSectionsToRender === 'function')
      ? cartEl.getSectionsToRender().map(function(s){ return s.id; })
      : null;

    variantIds.reduce(function(chain, variantId){
      return chain.then(function(){
        var body = { id: variantId, quantity: 1 };
        if (sectionIds) body.sections = sectionIds;
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(body)
        })
        .then(function(r){ return r.json().then(function(data){ return { ok: r.ok, data: data }; }); })
        .then(function(result){
          if (!result.ok){
            console.error('[BPB] échec ajout supplément', variantId, result.data);
          } else {
            console.log('[BPB] supplément ajouté', variantId, result.data);
            if (cartEl && typeof cartEl.renderContents === 'function' && result.data.sections){
              cartEl.renderContents(result.data);
            }
          }
        })
        .catch(function(err){ console.error('[BPB] erreur réseau supplément', variantId, err); });
      });
    }, Promise.resolve());
  }

  // Abonnement UNIQUE pour toute la durée de vie de la page. Dawn réexécute ce
  // script après un changement de variante (mise à jour AJAX de la section) —
  // sans ce garde-fou, chaque réexécution créait un nouvel abonnement, et donc
  // un supplément ajouté en double par soumission. En plus : on déduplique les
  // IDs de variante juste avant l'ajout, pour ne JAMAIS pouvoir ajouter le même
  // supplément deux fois lors d'un seul événement "cart-update", quelle que soit
  // la cause (état obsolète, plusieurs .bpb-cfg-section présents en même temps, etc.).
  if (!window.__bpbCartUpdateSubscribed && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate){
    window.__bpbCartUpdateSubscribed = true;
    subscribe(PUB_SUB_EVENTS.cartUpdate, function(eventData){
      // Dawn publie ce même événement pour bien plus que "ajouter au panier" —
      // notamment quand on retire un article ou change sa quantité (source: 'cart-items').
      // On ne doit réagir QUE lors d'un véritable ajout via le formulaire produit.
      if (!eventData || eventData.source !== 'product-form') {
        console.log('[BPB] cart-update ignoré (source: ' + (eventData && eventData.source) + ')');
        return;
      }
      console.log('[BPB] cart-update reçu, ajout des suppléments…');
      var seen = {};
      document.querySelectorAll('.bpb-cfg-section').forEach(function(root){
        if (!root.__bpbState) return;
        Object.keys(root.__bpbState).forEach(function(g){
          [].concat(root.__bpbState[g]).forEach(function(it){
            if (it && it.variantId) seen[it.variantId] = true;
          });
        });
      });
      addPendingSupplements(Object.keys(seen));
    });
  }

  function initBpbConfigurateur(root){
    if (!root || root.dataset.bpbInit) return;
    root.dataset.bpbInit = '1';

    var sectionId = root.dataset.bpbSectionId;
    var imgDataEl = document.getElementById('bpb-images-' + sectionId);
    var imgs = imgDataEl ? JSON.parse(imgDataEl.textContent) : [];

    var sectionRoot = document.querySelector('[data-section="' + sectionId + '"]') || document;
    var galleryWrapper = sectionRoot.querySelector('[data-bpb="gallery"]');
    var mediaGalleryEl = galleryWrapper ? galleryWrapper.querySelector('media-gallery') : null;

    var state = {};
    root.__bpbState = state;

    // Coincidencia EXACTA (sin distinguir exterior/interior): el texto alternativo
    // de la foto debe ser igual al nombre de la opción. Sin marca "int" ni nada raro —
    // cada producto tiene sus propias fotos con sus propios alt text.
    function findImageFor(nom){
      var needle = nom.trim().toLowerCase();
      var hit = imgs.find(function(im){
        return im.alt && im.alt.trim().toLowerCase() === needle;
      });
      return hit || null;
    }

    function swapGallery(imgEntry){
      if (!imgEntry || !imgEntry.media_id) return;
      // La galería nativa de Dawn se controla haciendo clic en su propia miniatura :
      // <li data-target="{{ section.id }}-{{ media.id }}"><button>...</button></li>
      var target = sectionId + '-' + imgEntry.media_id;
      var thumbBtn = sectionRoot.querySelector('[data-target="' + target + '"] button');
      if (thumbBtn){
        thumbBtn.click();
      } else if (galleryWrapper){
        // Repli : si no hay miniatura visible (ex. mobile sans miniatures), on change directement l'image active
        var activeImg = galleryWrapper.querySelector('[data-media-id="' + target + '"] img');
        if (activeImg && imgEntry.src) activeImg.src = imgEntry.src;
      }
      if (window.matchMedia('(max-width: 989px)').matches && galleryWrapper){
        galleryWrapper.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    function render(){
      setProp('Couleur du panneau extérieur', state['Couleur du panneau extérieur']);
      setProp('Couleur du panneau intérieur', state['Couleur du panneau intérieur']);
      setProp('Ouverture', state['Ouverture']);
      setProp('Ferrures', state['Ferrures']);
      setProp('Options additionnelles', state['Options']);
    }

    function setProp(name, entry){
      var input = root.querySelector('[data-bpb-prop="' + name + '"]');
      if (!input) return;
      if (!entry){ input.value = ''; return; }
      var arr = [].concat(entry);
      input.value = arr.map(function(it){ return it.val + (it.price ? ' (+' + it.price + '€)' : ''); }).join(', ');
    }

    // ---- Groupes "photo" : Couleur extérieure / intérieure ----
    root.querySelectorAll('[data-bpb-type="photo"]').forEach(function(group){
      var name = group.dataset.bpbGroup;
      var preview = group.dataset.bpbPreview === '1';
      var valueEl = group.querySelector('[data-bpb="value"]');
      var wrap = group.querySelector('[data-bpb="options"]');
      var pending = wrap.querySelectorAll('[data-bpb-pending]');

      // Filtre auto : n'affiche que les swatches pour lesquels CE produit a une photo
      pending.forEach(function(el){
        var hit = findImageFor(el.dataset.match);
        if (hit){
          el.removeAttribute('hidden');
          el.dataset.img = hit.src;
          el.dataset.mediaId = hit.media_id;
          var imgEl = el.querySelector('[data-bpb-img]');
          if (imgEl) imgEl.src = hit.src;
        } else {
          el.remove();
        }
      });

      var els = wrap.querySelectorAll('.bpb-psw');
      els.forEach(function(el, i){
        if (i === 0) el.classList.add('is-on');
        el.addEventListener('click', function(){
          els.forEach(function(x){ x.classList.remove('is-on'); });
          el.classList.add('is-on');
          state[name] = { val: el.dataset.val, price: 0 };
          if (valueEl) valueEl.textContent = el.dataset.val;
          if (preview) swapGallery({ src: el.dataset.img, media_id: el.dataset.mediaId });
          render();
        });
      });
      var on = wrap.querySelector('.bpb-psw.is-on');
      if (on){
        state[name] = { val: on.dataset.val, price: 0 };
        if (valueEl) valueEl.textContent = on.dataset.val;
      }
    });

    // ---- Groupe "open" : Ouverture ----
    root.querySelectorAll('[data-bpb-type="open"]').forEach(function(group){
      var name = group.dataset.bpbGroup;
      var els = group.querySelectorAll('.bpb-open-card');
      els.forEach(function(el){
        el.addEventListener('click', function(){
          els.forEach(function(x){ x.classList.remove('is-on'); });
          el.classList.add('is-on');
          state[name] = { val: el.dataset.val, price: 0 };
          render();
        });
      });
      var on = group.querySelector('.bpb-open-card.is-on');
      if (on) state[name] = { val: on.dataset.val, price: 0 };
    });

    // ---- Groupe "pdd" : Ferrures (liste déroulante avec photo) ----
    root.querySelectorAll('[data-bpb-type="pdd"]').forEach(function(group){
      var name = group.dataset.bpbGroup;
      var dd = group.querySelector('[data-bpb="pdd"]');
      var trigger = group.querySelector('[data-bpb="pdd-trigger"]');
      var triggerImg = group.querySelector('[data-bpb="pdd-trigger-img"]');
      var triggerText = group.querySelector('[data-bpb="pdd-trigger-text"]');
      var opts = group.querySelectorAll('.bpb-pdd-opt');

      trigger.addEventListener('click', function(){ dd.classList.toggle('is-open'); });
      document.addEventListener('click', function(e){ if (!dd.contains(e.target)) dd.classList.remove('is-open'); });

      opts.forEach(function(o){
        o.addEventListener('click', function(){
          opts.forEach(function(x){ x.classList.remove('is-on'); });
          o.classList.add('is-on');
          if (triggerImg){ triggerImg.src = o.dataset.img; triggerImg.removeAttribute('hidden'); }
          if (triggerText) triggerText.textContent = o.querySelector('b').textContent;
          state[name] = {
            val: o.dataset.val,
            price: parseInt(o.dataset.price || '0', 10),
            variantId: o.dataset.variantId || null
          };
          dd.classList.remove('is-open');
          render();
        });
      });
    });

    // ---- Toggles : Accessoires (multi) ----
    root.querySelectorAll('.bpb-toggle-row').forEach(function(row){
      var t = row.querySelector('.bpb-toggle');
      t.addEventListener('click', function(){
        t.classList.toggle('is-on');
        var key = '__toggle_' + row.dataset.val;
        if (t.classList.contains('is-on')){
          state[key] = {
            val: row.dataset.val,
            price: parseInt(row.dataset.price || '0', 10),
            variantId: row.dataset.variantId || null
          };
        } else {
          delete state[key];
        }
        var opts = Object.keys(state).filter(function(k){ return k.indexOf('__toggle_') === 0; }).map(function(k){ return state[k]; });
        if (opts.length) state['Options'] = opts; else delete state['Options'];
        render();
      });
    });

    // ---- Validation avant l'ajout au panier natif ----
    var productForm = document.getElementById('product-form-' + sectionId);
    if (productForm){
      productForm.addEventListener('submit', function(e){
        var required = Array.prototype.map.call(
          root.querySelectorAll('[data-bpb-required="1"]'),
          function(g){ return g.dataset.bpbGroup; }
        );
        var missing = required.filter(function(g){ return !state[g]; });
        if (missing.length){
          e.preventDefault();
          e.stopImmediatePropagation();
          var firstGroup = root.querySelector('[data-bpb-group="' + missing[0] + '"]');
          if (firstGroup){
            firstGroup.scrollIntoView({ behavior: 'smooth', block: 'center' });
            firstGroup.style.outline = '2px solid #b3261e';
            setTimeout(function(){ firstGroup.style.outline = ''; }, 1600);
          }
          window.alert('Merci de sélectionner : ' + missing.join(', ') + '.');
        }
      }, true);
    }

    render();
  }

  function initAll(){
    document.querySelectorAll('.bpb-cfg-section').forEach(initBpbConfigurateur);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', function(e){
    var root = e.target.querySelector ? e.target.querySelector('.bpb-cfg-section') : null;
    if (root) initBpbConfigurateur(root);
  });
  // Au cas où le DOM est déjà prêt (script chargé en defer après le HTML)
  if (document.readyState !== 'loading') initAll();
})();